import { createStore } from 'vuex'
import layout from './modules/layout';
import menu from './modules/menu'
import language from "./modules/language"

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    layout,
    menu,
    language
  }
})
